// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_af-0";
export var optionCard = "_af-1";